import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import SiteContainer from '../styles/SiteContainer'
import Spacer from '../styles/Spacer'
import roamingGlobe from '../../static/images/roaming-globe.svg'
import roamingTab from '../../static/images/roaming-tab.svg'
import callingAbroadTab from '../../static/images/calling-abroad-tab.svg'
import { HeadingContainer, Tabs, AltPara } from '../styles/Roaming'

export default function RoamingHeader({ selected }) {
  return (
    <HeadingContainer>
      <SiteContainer>
        <img
          src={roamingGlobe}
          alt="Roaming & international globe icon."
          data-testid="globe-icon"
        />
        <h1 data-testid="calling-abroad-page-title">Roaming & International</h1>
        <AltPara data-testid="calling-abroad-page-subheading">
          Travelling or calling and texting abroad with SMARTY.
          <br />
          Pay for what you use. Get what you don’t use back.
        </AltPara>
        <Spacer />
        <Tabs>
          <Link
            to="/roaming/"
            className={selected === 'roaming' ? 'selected' : ''}
          >
            <img src={roamingTab} alt="" />
            Travelling abroad
          </Link>
          <Link
            to="/calling-abroad/"
            className={selected === 'calling-abroad' ? 'selected' : ''}
          >
            <img src={callingAbroadTab} alt="" />
            International calling
          </Link>
        </Tabs>
      </SiteContainer>
    </HeadingContainer>
  )
}

RoamingHeader.propTypes = {
  selected: PropTypes.string,
}

RoamingHeader.defaultProps = {
  selected: '',
}
